export default "__VITE_ASSET__14ef3064__"